import {PRIVATE_ENDPOINTS} from '@/constants/api'
import {deleteData, downloadBlob,getData, getExternalData, patchData, postData, postForm} from '@/services/api'

/**
 * 👥 User API Service
 */
export const UserService = {
  getAll: (params?: object) => getData(PRIVATE_ENDPOINTS.user.all, params),
  getOne: (id: number) => getData(PRIVATE_ENDPOINTS.user.single(id)),
  create: (data: object) => postData(PRIVATE_ENDPOINTS.user.create, data),
  update: (id: number, data: object) => patchData(PRIVATE_ENDPOINTS.user.update(id), data),
  delete: (id: number) => deleteData(PRIVATE_ENDPOINTS.user.delete(id)),
}

/**
 * 👤 Customer API Service
 */
export const CustomerService = {
  getAll: (params?: object) => getData(PRIVATE_ENDPOINTS.customer.all, params),
  getOne: (id: number) => getData(PRIVATE_ENDPOINTS.customer.single(id)),
  create: (data: object) => postData(PRIVATE_ENDPOINTS.customer.create, data),
  update: (id: number, data: object) => patchData(PRIVATE_ENDPOINTS.customer.update(id), data),
  delete: (id: number) => deleteData(PRIVATE_ENDPOINTS.customer.delete(id)),
}

/**
 * 📋 Profilo API Service
 */
export const ProfiloService = {
  getAll: (params?: object) => getData(PRIVATE_ENDPOINTS.profilo.all, params),
  getOne: (id: number) => getData(PRIVATE_ENDPOINTS.profilo.single(id)),
  create: (data: object) => postData(PRIVATE_ENDPOINTS.profilo.create, data),
  update: (id: number, data: object) => patchData(PRIVATE_ENDPOINTS.profilo.update(id), data),
  delete: (id: number) => deleteData(PRIVATE_ENDPOINTS.profilo.delete(id)),
}

/**
 * 🔢 Numerazione API Service
 */
export const NumerazioneService = {
  getAll: (params?: object) => getData(PRIVATE_ENDPOINTS.numerazione.all, params),
  getOne: (id: number) => getData(PRIVATE_ENDPOINTS.numerazione.single(id)),
  create: (data: object) => postData(PRIVATE_ENDPOINTS.numerazione.create, data),
  update: (id: number, data: object) => patchData(PRIVATE_ENDPOINTS.numerazione.update(id), data),
  delete: (id: number) => deleteData(PRIVATE_ENDPOINTS.numerazione.delete(id)),
}

/**
 * 🏗️ Cantiere API Service
 */
export const CantiereService = {
  getAll: (params?: object) => getData(PRIVATE_ENDPOINTS.cantiere.all, params),
  getOne: (id: number) => getData(PRIVATE_ENDPOINTS.cantiere.single(id)),
  create: (data: object) => postData(PRIVATE_ENDPOINTS.cantiere.create, data),
  update: (id: number, data: object) => patchData(PRIVATE_ENDPOINTS.cantiere.update(id), data),
  delete: (id: number) => deleteData(PRIVATE_ENDPOINTS.cantiere.delete(id)),
}

/**
 * 🏞️ Parco API Service
 */
export const ParcoService = {
  getAll: (params?: object) => getData(PRIVATE_ENDPOINTS.parco.all, params),
  getOne: (id: number) => getData(PRIVATE_ENDPOINTS.parco.single(id)),
  create: (data: object) => postData(PRIVATE_ENDPOINTS.parco.create, data),
  update: (id: number, data: object) => patchData(PRIVATE_ENDPOINTS.parco.update(id), data),
  delete: (id: number) => deleteData(PRIVATE_ENDPOINTS.parco.delete(id)),
}

/**
 * 📌 Login API Service
 */
export const LoginService = {
  login: (data: object) => postData(PRIVATE_ENDPOINTS.auth.login, data),
}

/**
 * 🚗 Vettura API Service
 */
export const VetturaService = {
  getAll: (params?: object) => getData(PRIVATE_ENDPOINTS.vettura.all, params),
  getOne: (id: number) => getData(PRIVATE_ENDPOINTS.vettura.single(id)),
  create: (data: object) => postData(PRIVATE_ENDPOINTS.vettura.create, data),
  update: (id: number, data: object) => patchData(PRIVATE_ENDPOINTS.vettura.update(id), data),
  delete: (id: number) => deleteData(PRIVATE_ENDPOINTS.vettura.delete(id)),
  getStatistiche: (params?: object) => getData(PRIVATE_ENDPOINTS.vettura.statistiche, params),
  getDashboardStats: (params?: object) => getData(PRIVATE_ENDPOINTS.vettura.dashboardStats, params),
  bulkApprove: (ids: number[]) => postData(PRIVATE_ENDPOINTS.vettura.bulkApprove, { ids }),

  downloadFoto: (id: number): Promise<Blob> => downloadBlob(PRIVATE_ENDPOINTS.vettura.downloadFoto(id)),
  uploadFoto: (id: number, data: FormData) => postForm(PRIVATE_ENDPOINTS.vettura.uploadFoto(id), data),
  downloadFirma: (id: number): Promise<Blob> => downloadBlob(PRIVATE_ENDPOINTS.vettura.downloadFirma(id)),
}

/**
 * 💼 Job API Service
 */
export const JobService = {
  getAll: (params?: object) => getData(PRIVATE_ENDPOINTS.job.all, params),
  getOne: (id: number) => getData(PRIVATE_ENDPOINTS.job.single(id)),
  create: (data: object) => postData(PRIVATE_ENDPOINTS.job.create, data),
  update: (id: number, data: object) => patchData(PRIVATE_ENDPOINTS.job.update(id), data),
  delete: (id: number) => deleteData(PRIVATE_ENDPOINTS.job.delete(id)),
}

/**
 * 📄 Fattura API Service
 */
export const FatturaService = {
  getAll: (params?: object) => getData(PRIVATE_ENDPOINTS.fattura.all, params),
  getOne: (id: number) => getData(PRIVATE_ENDPOINTS.fattura.single(id)),
  create: (data: object) => postData(PRIVATE_ENDPOINTS.fattura.create, data),
  update: (id: number, data: object) => patchData(PRIVATE_ENDPOINTS.fattura.update(id), data),
  delete: (id: number) => deleteData(PRIVATE_ENDPOINTS.fattura.delete(id)),

  regenerate: (id: number) => postData(PRIVATE_ENDPOINTS.fattura.regenerate(id), {}),
  notaCredito: (id: number, data: object) => postData(PRIVATE_ENDPOINTS.fattura.notaCredito(id), data),
  uploadPdf: (id: number, data: FormData) => postData(PRIVATE_ENDPOINTS.fattura.uploadPdf(id), data),
  downloadPdf: (id: number): Promise<Blob> => downloadBlob(PRIVATE_ENDPOINTS.fattura.downloadPdf(id)),
  getStatistiche: (params?: object) => getData(PRIVATE_ENDPOINTS.fattura.statistiche, params),
}

